import * as React from 'react';
import { Separator, Spinner, Text, TvComparison, useAnalytics } from 'telia-front-react';
import { TRANSLATIONS_APP_NAME } from '@telia-common-components/shared';
import ChannelSearch from '../../common/ChannelSearch';
import { createChannelsGroup, createChannelsMap, mapChannelsInfo } from '../../util/TvComparisonChannelMapper';
import { filterChannelsNotAvailableInSelectedPackages, resolveVisiblePacketNames, mapChannelResults, mapThemeResults } from '../../util/TvComparisonFilterUtil';
import { getIconByService } from '../../util/TvComparisonIconMapper';
import { createThemePackagesGroup, mapThemePackages } from '../../util/TvComparisonThemePackageMapper';
const TvB2BPacketDetailsModalContent = (props) => {
    var _a, _b, _c;
    const { translate, translations, icons, filterState, filterActions, themePackagesHidden, shownChannelsCount, shownThemesCount, urlData, chosenPacket } = props;
    const { packagePrices, packageNames, packageSizes, channels, themePackages } = props.packagesResponse;
    if (!packageNames.length || !channels.length || !(translations === null || translations === void 0 ? void 0 : translations[TRANSLATIONS_APP_NAME])) {
        return (React.createElement(Text, { className: "text-center" },
            React.createElement(Spinner, null)));
    }
    const { push: pushAnalytics } = useAnalytics();
    const getIcon = (service) => {
        return getIconByService(service, icons);
    };
    const packets = packagePrices
        .slice()
        .filter((offer) => (chosenPacket ? chosenPacket === offer.name : true))
        .map((pkg) => ({
        name: `${translate(`tvcomparison.heading.package.${pkg === null || pkg === void 0 ? void 0 : pkg.name}`)}`,
        price: `${pkg.price} ${translate('tvcomparison.price.permonthAndVat')}`,
        channelsAmount: `${translate('tvcomparison.package.channelsAmount', {
            amount: `${packageSizes.find((nameAndSize) => pkg.name === nameAndSize.name).size}`
        })}`
    }));
    const visiblePackageNames = resolveVisiblePacketNames(packageNames, chosenPacket ? [chosenPacket] : packageNames, packagePrices);
    const channelsMap = createChannelsMap(channels);
    let themes = [];
    let filteredChannels = [];
    const isSearch = !!((_a = filterState.selectedItem) === null || _a === void 0 ? void 0 : _a.label);
    const commonMapperProps = {
        packageNames: visiblePackageNames,
        translate: translate,
        pushAnalytics,
        urlData: urlData,
        pricePerMonthLabel: 'tvcomparison.price.permonthAndVat',
        getIcon,
        packagesWithoutPriceExcluded: true
    };
    if ((themePackages === null || themePackages === void 0 ? void 0 : themePackages.length) || (channels === null || channels === void 0 ? void 0 : channels.length)) {
        const channelsResultMap = mapChannelsInfo(channels, {
            ...commonMapperProps,
            identifier: 'ALL'
        });
        const themesResultMap = mapThemePackages(themePackages, channelsMap, {
            ...commonMapperProps,
            identifier: 'ALL'
        });
        themes = mapThemeResults(themesResultMap, themePackages).map((theme) => ({
            ...theme,
            packetPrices: theme.packetPrices.map((price) => {
                var _a;
                if (price.label) {
                    return price;
                }
                else {
                    return { label: (_a = price.price) === null || _a === void 0 ? void 0 : _a.text };
                }
            })
        }));
        filteredChannels = mapChannelResults(channelsResultMap, channels);
    }
    if (isSearch) {
        themes = (_b = themes.slice()) === null || _b === void 0 ? void 0 : _b.filter((p) => { var _a, _b; return (_a = p.title) === null || _a === void 0 ? void 0 : _a.toUpperCase().includes((((_b = filterState.selectedItem) === null || _b === void 0 ? void 0 : _b.label) || '').toUpperCase()); });
        filteredChannels = (_c = filteredChannels === null || filteredChannels === void 0 ? void 0 : filteredChannels.slice()) === null || _c === void 0 ? void 0 : _c.filter((c) => { var _a, _b; return (_a = c.title) === null || _a === void 0 ? void 0 : _a.toUpperCase().includes((((_b = filterState.selectedItem) === null || _b === void 0 ? void 0 : _b.label) || '').toUpperCase()); });
    }
    filteredChannels = filterChannelsNotAvailableInSelectedPackages(visiblePackageNames, packageNames, filteredChannels);
    const pickableChannels = filteredChannels
        .filter((channel) => channel.packetPrices.some((price) => { var _a; return !((_a = price.price) === null || _a === void 0 ? void 0 : _a.isIncluded); }))
        .map((channel) => ({
        ...channel,
        packetPrices: channel.packetPrices.map((price) => {
            var _a;
            if (price.label) {
                return price;
            }
            else {
                return { label: (_a = price.price) === null || _a === void 0 ? void 0 : _a.text };
            }
        })
    }));
    const commonCreateGroupProps = { translate, filterActions };
    const themePacketsGroup = createThemePackagesGroup({
        ...commonCreateGroupProps,
        themes,
        isAllShown: filterState.isAllThemesShown,
        shownItemsCount: shownThemesCount || 5
    });
    const channelsGroup = createChannelsGroup({
        ...commonCreateGroupProps,
        channels: pickableChannels,
        isAllShown: filterState.isAllChannelsShown,
        filterActions,
        shownItemsCount: shownChannelsCount,
        labelKey: 'tvcomparison.pickableChannels'
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { className: 'text-center' },
            React.createElement(ChannelSearch, { translate: translate, suggestions: filterState.channelSuggestionItems, onSelect: filterActions.selectSuggestionItem, fuzzySearch: filterState.fuzzySearch, selectedItem: filterState.selectedItem }),
            isSearch && (React.createElement("p", { className: "text-center" }, translate('tvcomparison.results.number', { amount: String(pickableChannels.length + themes.length), search: filterState.selectedItem.label }))),
            React.createElement(Separator, { spacing: "medium", color: "invisible" })),
        React.createElement(TvComparison, { sections: [
                { type: 'themePackets', data: themePackagesHidden ? undefined : themePacketsGroup },
                { type: 'channels', data: channelsGroup }
            ], packets: packets, soundLabel: `${translate('tvcomparison.channels.audio')}`, subTitlesLabel: `${translate('tvcomparison.channels.subtitles')}`, onDetailsInfoToggle: (id, element, isOpen) => pushAnalytics(`Link - ${element} - ${id} - avatud: ${isOpen}`) })));
};
export default TvB2BPacketDetailsModalContent;
